import updateDuplicateParams from './update-duplicate-params';
import preProcessPlaybook from 'app/playbook-editor/pre-process-playbook';
import { globalModalStore } from '@ion/global';

export const onSaveRevision = ({ uploadedData, uploadType, playbookState, uploadState }) => {
  const {
    msg,
    p: playbookJson,
    c: connectionJson,
  } = updateDuplicateParams({
    uploadedData,
    uploadType,
    playbook: playbookState.playbook,
    connection: playbookState.connectionJSON,
  });

  const { playbook, connection, opIndices } = preProcessPlaybook(
    playbookJson,
    connectionJson,
    {},
    playbookState.opIndices
  );

  playbookState.applyUpload(playbook, connection, opIndices);
  uploadState.resetModal();

  if (msg !== null) {
    return globalModalStore.addNotification({
      title: 'Check your params',
      message: msg,
    });
  }
};
